import { useEffect, useRef, useState } from 'react';

export default function useTimer({ duration, onEnd, autoStart = true }) {
  const [timeLeft, setTimeLeft] = useState(duration);
  const [isRunning, setIsRunning] = useState(autoStart);
  const [timeEnd, setTimeEnd] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!isRunning || timeEnd) return;

    timerRef.current = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1000) {
          clearInterval(timerRef.current);
          setIsRunning(false);
          setTimeEnd(true);
          onEnd();
          return 0;
        }
        return prev - 1000;
      });
    }, 1000);

    // eslint-disable-next-line consistent-return
    return () => clearInterval(timerRef.current);
  }, [isRunning]);

  const start = () => {
    clearInterval(timerRef.current);
    setTimeLeft(duration);
    setTimeEnd(false);
    setIsRunning(true);
  };

  const pause = () => {
    clearInterval(timerRef.current);
    setIsRunning(false);
  };

  const resume = () => {
    if (timeLeft > 0 && !timeEnd) {
      setIsRunning(true);
    }
  };

  const reset = () => {
    clearInterval(timerRef.current);
    setTimeLeft(duration);
    setIsRunning(false);
    setTimeEnd(false);
  };

  return { timeLeft, isRunning, timeEnd, start, pause, resume, reset };
}
